// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file devtool/v1/model.proto (package devtool.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { CSVFileData } from "../../types/v1/csv_pb";
import { file_types_v1_csv } from "../../types/v1/csv_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file devtool/v1/model.proto.
 */
export const file_devtool_v1_model: GenFile = /*@__PURE__*/
  fileDesc("ChZkZXZ0b29sL3YxL21vZGVsLnByb3RvEgpkZXZ0b29sLnYxIkIKG1NpbXVsYXRlUEZFSW5wdXRDU1ZzWmlwRmlsZRIRCglmaWxlX25hbWUYASABKAkSEAoIemlwX2ZpbGUYAiABKAwijQEKJVNpbXVsYXRlUEZFT3V0cHV0Q1NWc0J5T3JnYW5pemF0aW9uSUQSDwoHY2FzZV9pZBgBIAEoCRIXCg9vcmdhbml6YXRpb25faWQYAiABKAkSOgoPcGZlX291dHB1dF9jc3ZzGAMgASgLMiEuZGV2dG9vbC52MS5TaW11bGF0ZVBGRU91dHB1dENTVnMicAohU2ltdWxhdGVQRkVPdXRwdXRDU1ZzRm9yUG9ydGZvbGlvEg8KB2Nhc2VfaWQYASABKAkSOgoPcGZlX291dHB1dF9jc3ZzGAIgASgLMiEuZGV2dG9vbC52MS5TaW11bGF0ZVBGRU91dHB1dENTVnMi5AEKF0NTVkZpbGVEYXRhV2l0aERhdGFUeXBlEicKCWRhdGFfdHlwZRgBIAEoDjIULmRldnRvb2wudjEuRGF0YVR5cGUSFAoMZ3JhcGhfdGFyZ2V0GAIgASgIEhoKEnNwcmVhZHNoZWV0X3RhcmdldBgDIAEoCBIsCg1jc3ZfZmlsZV9kYXRhGAQgASgLMhUudHlwZXMudjEuQ1NWRmlsZURhdGESQAoWZ3JhcGhfYXhpc19vcmllbnRhdGlvbhgFIAEoDjIgLmRldnRvb2wudjEuR3JhcGhBeGlzT3JpZW50YXRpb24iXgoVU2ltdWxhdGVQRkVPdXRwdXRDU1ZzEkUKGGNzdl9maWxlc193aXRoX2RhdGFfdHlwZRgCIAMoCzIjLmRldnRvb2wudjEuQ1NWRmlsZURhdGFXaXRoRGF0YVR5cGUiNwoPQ2FsY3VsYXRpb25UaW1lEhIKCnN0YXJ0X3RpbWUYASABKAkSEAoIZW5kX3RpbWUYAiABKAkqbwoUR3JhcGhBeGlzT3JpZW50YXRpb24SMgouR1JBUEhfQVhJU19PUklFTlRBVElPTl9DT0xVTU5fQVNfWF9VTlNQRUNJRklFRBAAEiMKH0dSQVBIX0FYSVNfT1JJRU5UQVRJT05fUk9XX0FTX1gQASrHAgoIRGF0YVR5cGUSGQoVREFUQV9UWVBFX1VOU1BFQ0lGSUVEEAASGAoUREFUQV9UWVBFX1BGRV9SRVNVTFQQARIkCiBEQVRBX1RZUEVfU0VMRUNURURfRElTVFJJQlVUSU9OUxACEhwKGERBVEFfVFlQRV9TTkFQU0hPVF9EQVRBUxADEhUKEURBVEFfVFlQRV9TUEFOX0lNEAQSFwoTREFUQV9UWVBFX1BGRV9JTlBVVBAFEhEKDURBVEFfVFlQRV9GRUUQBhIcChhEQVRBX1RZUEVfREVQT1NJVF9BTU9VTlQQBxInCiNEQVRBX1RZUEVfQ0hFQ0tfQ1JFRElUX1JJU0tfUkVTVUxUUxAIEhcKE0RBVEFfVFlQRV9WTV9TRVRUTEUQCRIfChtEQVRBX1RZUEVfUE9SVEZPTElPX0RFVEFJTFMQCkKtAQoOY29tLmRldnRvb2wudjFCCk1vZGVsUHJvdG9QAVpGZ2l0aHViLmNvbS9lbmVjaGFpbi9lcG9zaXRpb24tYXBwL2JhY2tlbmQvZ2VuL3Byb3RvL2RldnRvb2wvdjE7ZGV2dG9vbKICA0RYWKoCCkRldnRvb2wuVjHKAgpEZXZ0b29sXFYx4gIWRGV2dG9vbFxWMVxHUEJNZXRhZGF0YeoCC0RldnRvb2w6OlYxYgZwcm90bzM", [file_types_v1_csv]);

/**
 * @generated from message devtool.v1.SimulatePFEInputCSVsZipFile
 */
export type SimulatePFEInputCSVsZipFile = Message<"devtool.v1.SimulatePFEInputCSVsZipFile"> & {
  /**
   * @generated from field: string file_name = 1;
   */
  fileName: string;

  /**
   * @generated from field: bytes zip_file = 2;
   */
  zipFile: Uint8Array;
};

/**
 * Describes the message devtool.v1.SimulatePFEInputCSVsZipFile.
 * Use `create(SimulatePFEInputCSVsZipFileSchema)` to create a new message.
 */
export const SimulatePFEInputCSVsZipFileSchema: GenMessage<SimulatePFEInputCSVsZipFile> = /*@__PURE__*/
  messageDesc(file_devtool_v1_model, 0);

/**
 * @generated from message devtool.v1.SimulatePFEOutputCSVsByOrganizationID
 */
export type SimulatePFEOutputCSVsByOrganizationID = Message<"devtool.v1.SimulatePFEOutputCSVsByOrganizationID"> & {
  /**
   * EOD or EODSpotToFuture
   *
   * @generated from field: string case_id = 1;
   */
  caseId: string;

  /**
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * @generated from field: devtool.v1.SimulatePFEOutputCSVs pfe_output_csvs = 3;
   */
  pfeOutputCsvs?: SimulatePFEOutputCSVs;
};

/**
 * Describes the message devtool.v1.SimulatePFEOutputCSVsByOrganizationID.
 * Use `create(SimulatePFEOutputCSVsByOrganizationIDSchema)` to create a new message.
 */
export const SimulatePFEOutputCSVsByOrganizationIDSchema: GenMessage<SimulatePFEOutputCSVsByOrganizationID> = /*@__PURE__*/
  messageDesc(file_devtool_v1_model, 1);

/**
 * @generated from message devtool.v1.SimulatePFEOutputCSVsForPortfolio
 */
export type SimulatePFEOutputCSVsForPortfolio = Message<"devtool.v1.SimulatePFEOutputCSVsForPortfolio"> & {
  /**
   * EOD or EODSpotToFuture
   *
   * @generated from field: string case_id = 1;
   */
  caseId: string;

  /**
   * @generated from field: devtool.v1.SimulatePFEOutputCSVs pfe_output_csvs = 2;
   */
  pfeOutputCsvs?: SimulatePFEOutputCSVs;
};

/**
 * Describes the message devtool.v1.SimulatePFEOutputCSVsForPortfolio.
 * Use `create(SimulatePFEOutputCSVsForPortfolioSchema)` to create a new message.
 */
export const SimulatePFEOutputCSVsForPortfolioSchema: GenMessage<SimulatePFEOutputCSVsForPortfolio> = /*@__PURE__*/
  messageDesc(file_devtool_v1_model, 2);

/**
 * @generated from message devtool.v1.CSVFileDataWithDataType
 */
export type CSVFileDataWithDataType = Message<"devtool.v1.CSVFileDataWithDataType"> & {
  /**
   * @generated from field: devtool.v1.DataType data_type = 1;
   */
  dataType: DataType;

  /**
   * @generated from field: bool graph_target = 2;
   */
  graphTarget: boolean;

  /**
   * @generated from field: bool spreadsheet_target = 3;
   */
  spreadsheetTarget: boolean;

  /**
   * @generated from field: types.v1.CSVFileData csv_file_data = 4;
   */
  csvFileData?: CSVFileData;

  /**
   * @generated from field: devtool.v1.GraphAxisOrientation graph_axis_orientation = 5;
   */
  graphAxisOrientation: GraphAxisOrientation;
};

/**
 * Describes the message devtool.v1.CSVFileDataWithDataType.
 * Use `create(CSVFileDataWithDataTypeSchema)` to create a new message.
 */
export const CSVFileDataWithDataTypeSchema: GenMessage<CSVFileDataWithDataType> = /*@__PURE__*/
  messageDesc(file_devtool_v1_model, 3);

/**
 * @generated from message devtool.v1.SimulatePFEOutputCSVs
 */
export type SimulatePFEOutputCSVs = Message<"devtool.v1.SimulatePFEOutputCSVs"> & {
  /**
   * @generated from field: repeated devtool.v1.CSVFileDataWithDataType csv_files_with_data_type = 2;
   */
  csvFilesWithDataType: CSVFileDataWithDataType[];
};

/**
 * Describes the message devtool.v1.SimulatePFEOutputCSVs.
 * Use `create(SimulatePFEOutputCSVsSchema)` to create a new message.
 */
export const SimulatePFEOutputCSVsSchema: GenMessage<SimulatePFEOutputCSVs> = /*@__PURE__*/
  messageDesc(file_devtool_v1_model, 4);

/**
 * @generated from message devtool.v1.CalculationTime
 */
export type CalculationTime = Message<"devtool.v1.CalculationTime"> & {
  /**
   * @generated from field: string start_time = 1;
   */
  startTime: string;

  /**
   * @generated from field: string end_time = 2;
   */
  endTime: string;
};

/**
 * Describes the message devtool.v1.CalculationTime.
 * Use `create(CalculationTimeSchema)` to create a new message.
 */
export const CalculationTimeSchema: GenMessage<CalculationTime> = /*@__PURE__*/
  messageDesc(file_devtool_v1_model, 5);

/**
 * @generated from enum devtool.v1.GraphAxisOrientation
 */
export enum GraphAxisOrientation {
  /**
   * 列をX軸として使用（デフォルト）
   *
   * @generated from enum value: GRAPH_AXIS_ORIENTATION_COLUMN_AS_X_UNSPECIFIED = 0;
   */
  COLUMN_AS_X_UNSPECIFIED = 0,

  /**
   * 行をX軸として使用
   *
   * @generated from enum value: GRAPH_AXIS_ORIENTATION_ROW_AS_X = 1;
   */
  ROW_AS_X = 1,
}

/**
 * Describes the enum devtool.v1.GraphAxisOrientation.
 */
export const GraphAxisOrientationSchema: GenEnum<GraphAxisOrientation> = /*@__PURE__*/
  enumDesc(file_devtool_v1_model, 0);

/**
 * @generated from enum devtool.v1.DataType
 */
export enum DataType {
  /**
   * @generated from enum value: DATA_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: DATA_TYPE_PFE_RESULT = 1;
   */
  PFE_RESULT = 1,

  /**
   * @generated from enum value: DATA_TYPE_SELECTED_DISTRIBUTIONS = 2;
   */
  SELECTED_DISTRIBUTIONS = 2,

  /**
   * @generated from enum value: DATA_TYPE_SNAPSHOT_DATAS = 3;
   */
  SNAPSHOT_DATAS = 3,

  /**
   * @generated from enum value: DATA_TYPE_SPAN_IM = 4;
   */
  SPAN_IM = 4,

  /**
   * @generated from enum value: DATA_TYPE_PFE_INPUT = 5;
   */
  PFE_INPUT = 5,

  /**
   * @generated from enum value: DATA_TYPE_FEE = 6;
   */
  FEE = 6,

  /**
   * @generated from enum value: DATA_TYPE_DEPOSIT_AMOUNT = 7;
   */
  DEPOSIT_AMOUNT = 7,

  /**
   * @generated from enum value: DATA_TYPE_CHECK_CREDIT_RISK_RESULTS = 8;
   */
  CHECK_CREDIT_RISK_RESULTS = 8,

  /**
   * @generated from enum value: DATA_TYPE_VM_SETTLE = 9;
   */
  VM_SETTLE = 9,

  /**
   * @generated from enum value: DATA_TYPE_PORTFOLIO_DETAILS = 10;
   */
  PORTFOLIO_DETAILS = 10,
}

/**
 * Describes the enum devtool.v1.DataType.
 */
export const DataTypeSchema: GenEnum<DataType> = /*@__PURE__*/
  enumDesc(file_devtool_v1_model, 1);

